import axios from "axios";
import { config } from '../config/config';
axios.defaults.baseURL = config.BACKEND_URL + '/api';


const restApi = {
  // Auth_API_Start
  setAuthToken: (token: string) => {
    axios.defaults.headers.common.Authorization = token;
  },

  getProjectInfor: async () => {
    const result = await axios.post("project-information")
    return result.data
  },


  loginStatus: async (authToken: string) => {
    const result = await axios.post("loginStatus", {}, {
      headers: { 'Content-Type': 'application/json', 'Authorization': authToken }
    })

    return result.data
  },

  login: async (data: Loginprops) => {
    const result = await axios.post("login", data)
    return result.data
  },

  deleteCourse: async (data: Loginprops) => {
    const result = await axios.post("login", data)
    return result.data
  },

  signup: async (data: SignUpProps) => {
    const result = await axios.post("signup", data)
    return result.data;
  },

  mailVerify: async (data: VerifyCodeProps) => {
    const result = await axios.post("mailVerify", data)
    return result.data;
  },

  requestVerifyCode: async () => {
    const result = await axios.post("settings/request-verify-code")
    return result.data;
  },

  sendEmail: async (data:MailDataProps) => {
    const result = await axios.post("/contact",data)
    return result;
  },

  settingMailVerify: async (data: Partial<VerifyCodeProps>) => {
    const result = await axios.post("settings/mailVerify", data)
    return result.data;
  },

  logOut: async () => {
    await axios.post("logout");
  },

  updateProfile: async (data: UpdateProfileProps) => {
    const result = await axios.post("update-profile", data)
    return result.data;
  },

  updateProfilePhoto: async (data: any) => {
    const result = await axios.post("update-profile-photo", data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })

    return result.data;
  },

  requestWithdraw: async () => {
    const result = await axios.post("request-withdraw");
    return result.data;
  },
  // Auth_API_End

  // Course_API_Start
  createCourse: async (data: any) => {
    const result = await axios.post("create-course", data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })

    return result.data;
  },

  updateCourse: async (data: UpdateCourseProps) => {
    const result = await axios.post("update-course", data)
    return result.data;
  },

  getBrowseCourse: async (lectureType: string) => {
    const result = await axios.post("browse-course", { lectureType })
    return result.data;
  },

  getCourseData: async (id: string) => {
    const result = await axios.post("course-data", { id })
    return result.data;
  },

  createPaymentIntent: async (id: string) => {
    const result = await axios.post("create-payment-intent", { id })
    return result.data;
  },

  createPaymentDocument: async (id: string,email:string) => {
    const result = await axios.post("create-payment-document", { id,email })
    return result.data;
  },


  submitReview: async (data: SubmitReviewProps) => {
    const result = await axios.post("submit-review", data)
    return result.data;
  },

  submitQuestion: async (data: SubmitQuestionProps) => {
    const result = await axios.post("submit-qa", data)
    return result.data;
  },

  submitAnswer: async (data: SubmitAnswerProps) => {
    const result = await axios.post("submit-answer", data)
    return result.data;
  },
  // Course_API_End
}

export { restApi };